import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import jquery from 'jquery'
import bootstrap from 'bootstrap-vue'
import ElementUI from 'element-ui'



import './common/css/iconfont.css'
import './common/css/animate.css'
import 'element-ui/lib/theme-chalk/index.css'



Vue.config.productionTip = false
// Vue.use(jquery)
Vue.use(bootstrap)
Vue.use(ElementUI)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
